"use client";

import isCookieBotEnabled from "src/lib/isCookiebotEnabled";
import styles from "./GDPRChangeButton.module.css";
import { locale } from "@locale";



//#region [Component]
export default function GDPRChangeButton() {
    if (!isCookieBotEnabled) return null;
    return <button onClick={() => window?.Cookiebot?.renew()} className={styles.GDPRChangeButton}>{locale.consent.cookieChangeButton}</button>;
}
//#endregion

//#region [Styles]

//#endregion